const checkIfCookieTagAdded = (tag) => Boolean(document.getElementById(tag));

export const injectCookieConsentBanner = () => {
  const tagName = 'cookieConsentInitAndLoad';
  const isCookieConsentPrevAdded = checkIfCookieTagAdded(tagName);
  if (!isCookieConsentPrevAdded) {
    const scriptLine = 'function OptanonWrapper() { }';
    const newScript1 = document.createElement('script');
    newScript1.setAttribute('id', tagName);
    newScript1.type = 'text/javascript';
    newScript1.setAttribute('src', 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js');
    newScript1.setAttribute('data-domain-script', '3a0cbb29-ac2e-47e7-aeac-c28ef3e6fcc4');
    document.head.appendChild(newScript1);

    const newScript2 = document.createElement('script');

    newScript2.type = 'text/javascript';
    const inlineScript2 = document.createTextNode(scriptLine);
    newScript2.appendChild(inlineScript2);
    document.head.appendChild(newScript2);
  }
};